export const comments_3399189 = {"data":{"data":[],"links":{}}}